import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetZone } from 'src/app/models/zone/getZone';
import { GetPin } from 'src/app/models/zone/getPin';
import { GetDigitalTwins } from 'src/app/models/digital-twins/getDigitalTwins';

@Injectable({
  providedIn: 'root'
})
export class DigitalTwinsService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'DigitalTwins';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetZone> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetZone>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  getListAll(idEnterprise: number,idHeadquarter: number): Observable<GetDigitalTwins> {
    return this.httpClient.get<GetDigitalTwins>(`${this.REQUEST_URL}/enterprise/${idEnterprise}/headquarter/${idHeadquarter}`);
  }

  create(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }
}
